<template>
    <div class="gam-v2-config">
        <div class="toolbar">
            <el-button type="primary" :loading="loading" @click="loadConfig">刷新</el-button>
            <el-button type="success" :loading="saving" :disabled="!dirty" @click="saveConfig">保存配置</el-button>
            <span v-if="dirty" class="dirty-text">有未保存更改</span>
        </div>

        <el-alert v-if="error" type="error" show-icon :closable="false" :title="error" style="margin-bottom: 12px"/>

        <section v-for="group in groupedConfigs" :key="group.key" class="config-section">
            <div class="section-title">{{ group.title }}</div>
            <el-table :data="group.rows" v-loading="loading" border style="width: 100%">
                <el-table-column prop="label" label="配置" width="220"/>
                <el-table-column prop="description" label="说明" min-width="320" show-overflow-tooltip/>
                <el-table-column label="当前值" width="260">
                    <template #default="scope">
                        <el-switch
                            v-if="scope.row.type === 'bool'"
                            v-model="form[scope.row.key]"
                            inline-prompt
                            active-text="开"
                            inactive-text="关"
                            @change="markDirty"
                        />
                        <el-input-number
                            v-else-if="scope.row.type === 'int'"
                            v-model="form[scope.row.key]"
                            :min="scope.row.min"
                            :max="scope.row.max"
                            :step="1"
                            controls-position="right"
                            style="width: 160px"
                            @change="markDirty"
                        />
                        <el-input v-else v-model="form[scope.row.key]" @input="markDirty"/>
                    </template>
                </el-table-column>
                <el-table-column label="默认值" width="120">
                    <template #default="scope">
                        <el-tag v-if="scope.row.type === 'bool'" :type="scope.row.default ? 'success' : 'info'" size="small">
                            {{ scope.row.default ? '开' : '关' }}
                        </el-tag>
                        <span v-else>{{ scope.row.default }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100">
                    <template #default="scope">
                        <el-tag :type="scope.row.stored ? 'warning' : 'info'" size="small">
                            {{ scope.row.stored ? '已覆盖' : '默认' }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </section>
    </div>
</template>

<script>
import {ElMessage} from "element-plus";
import axios from "ts-axios-new";

export default {
    name: "GAMV2Config",
    data() {
        return {
            loading: false,
            saving: false,
            dirty: false,
            error: '',
            configs: [],
            form: {},
        };
    },
    computed: {
        groupedConfigs() {
            const groups = [
                {key: 'alert', title: '报警开关', rows: []},
                {key: 'runtime', title: '运行参数', rows: []},
            ];
            const byKey = Object.fromEntries(groups.map((g) => [g.key, g]));
            (this.configs || []).forEach((row) => {
                const g = byKey[row.group] || byKey.runtime;
                g.rows.push(row);
            });
            return groups.filter((g) => g.rows.length);
        },
    },
    mounted() {
        this.loadConfig();
    },
    methods: {
        markDirty() {
            this.dirty = true;
        },
        async loadConfig() {
            this.loading = true;
            this.error = '';
            try {
                const res = await axios.get('/api/v2/gam/config');
                const d = res.data.data;
                if (d.errorMessage) {
                    this.error = d.errorMessage;
                    return;
                }
                this.configs = d.configs || [];
                const next = {};
                this.configs.forEach((row) => {
                    next[row.key] = row.value;
                });
                this.form = next;
                this.dirty = false;
            } catch (e) {
                this.error = '加载 GAM V2 配置失败';
            } finally {
                this.loading = false;
            }
        },
        async saveConfig() {
            this.saving = true;
            this.error = '';
            try {
                const res = await axios.put('/api/v2/gam/config', {values: this.form});
                const d = res.data.data;
                if (d.errorMessage) {
                    this.error = d.errorMessage;
                    return;
                }
                this.configs = d.configs || [];
                const next = {};
                this.configs.forEach((row) => {
                    next[row.key] = row.value;
                });
                this.form = next;
                this.dirty = false;
                ElMessage.success('GAM V2 配置已保存');
            } catch (e) {
                this.error = '保存 GAM V2 配置失败';
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.gam-v2-config {
    padding: 16px 24px;
}

.toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.dirty-text {
    color: var(--el-color-warning);
    font-size: 13px;
}

.config-section {
    margin-top: 16px;
}

.section-title {
    font-weight: 600;
    margin-bottom: 8px;
}
</style>
